import { patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { combineLatest, pipe, switchMap, tap, map, filter } from 'rxjs';
import { inject } from '@angular/core';
import { OfferTransport } from '@/new-transport/_models/transport.model';
import { TransportApiService } from '@/new-transport/_api/transport.api.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { withLoadingFeature } from '@/_signal-store-features/loading.feature.store';
import { combineIdsFromUrlParams } from '@/new-transport/_utils/combine-ids-from-url-params/combine-ids-from-url-params';

type State = {
	offerTransport: OfferTransport[];
};

const initialState: State = {
	offerTransport: [],
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function withOfferTransport() {
	return signalStoreFeature(
		withState(initialState),
		withLoadingFeature({
			offerTransportIsLoading: false,
		}),
		withMethods((store, apiService = inject(TransportApiService)) => ({
			fetchTransport: rxMethod<number[]>(
				pipe(
					tap(() => store.changeLoadingState('offerTransport', true)),
					switchMap((ids) =>
						apiService.getOfferTransport(ids).pipe(
							tapResponse({
								next: (offerTransport) =>
									patchState(store, (state) => ({
										...state,
										offerTransport,
									})),
								error: () => {
									throw new Error('Nie udało się pobrać danych o sprzedaży');
								},
								finalize: () => store.changeLoadingState('offerTransport', false),
							}),
						),
					),
				),
			),
		})),
		withHooks({
			onInit({ fetchTransport }, activatedRoute = inject(ActivatedRoute)) {
				combineLatest([activatedRoute.queryParams, activatedRoute.params])
					.pipe(
						map(([queryParams, params]) => combineIdsFromUrlParams(queryParams, params)),
						filter((ids) => ids.length > 0),
						takeUntilDestroyed(),
					)
					.subscribe((ids) => fetchTransport(ids));
			},
		}),
	);
}
